import { FilterMatchMode } from "primereact/api";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { ColumnFilterApplyTemplateOptions, ColumnFilterClearTemplateOptions, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useEffect, useState } from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";

export const TextMatchModeOptions = [
    { label: 'Contém', value: FilterMatchMode.CONTAINS },
    { label: 'Igual', value: FilterMatchMode.EQUALS },
    { label: 'Começa com', value: FilterMatchMode.STARTS_WITH },
    { label: 'Termina com', value: FilterMatchMode.ENDS_WITH },
]

export const NumberMatchModeOptions = [
    { label: 'Igual', value: FilterMatchMode.EQUALS },
    { label: 'Maior que', value: FilterMatchMode.GREATER_THAN },
    { label: 'Menor que', value: FilterMatchMode.LESS_THAN },
    { label: 'Maior ou igual', value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
    { label: 'Menor ou igual', value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
]


export const numberFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return <InputNumber
        value={options.value} onValueChange={(e) => options.filterCallback(e.value)}
        useGrouping={false} minFractionDigits={0} maxFractionDigits={0}
        placeholder="Escreva o filtro"
    />;
}
export const decimalFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return <InputNumber
        value={options.value} onValueChange={(e) => options.filterCallback(e.value)}
        useGrouping={false} minFractionDigits={1} maxFractionDigits={20}
        placeholder="Escreva o filtro" locale="pt-BR"
    />;
}

export const booleanFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return <Dropdown value={options.value} options={[
        { label: 'Sim', value: true },
        { label: 'Não', value: false }
    ]}
        onChange={(e: DropdownChangeEvent) => {
            options.filterCallback(e.value);
        }}
        optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
    />;
};

export const filterApplyTemplate = (options: ColumnFilterApplyTemplateOptions) => {
    return <Button type="button" label="Aplicar" onClick={options.filterApplyCallback} ></Button>;
};

export const filterClearTemplate = (options: ColumnFilterClearTemplateOptions) => {
    return <Button type="button" outlined label="Limpar" onClick={options.filterClearCallback} ></Button>;
};

export function getFilters(filter: DataTableFilterMeta | null | undefined): string {

    let filters = '';
    if (filter) {
        let filterCount = 0;
        filters += '?filters=';
        Object.keys(filter).forEach((key, index) => {
            if (key === 'null') return;

            let filterField = filter[key] as DataTableOperatorFilterMetaData;
            let value = filterField.constraints[0].value;

            if (value == null) return;


            filters += encodeURIComponent(filterCount > 0 ? ',' : '{');
            filterCount++;

            if (typeof value == "object") {
                if (value instanceof Date) {
                    filters += encodeURIComponent(`"${key}":{"value":${JSON.stringify(value) || ''}`);
                } else if (value instanceof Array) {
                    filters += encodeURIComponent(`"${key}":{"values":${JSON.stringify(value) || '[]'}`);
                } else {
                    filters += encodeURIComponent(`"${key}":{${Object.keys(value).map((valueKey) => `"${valueKey}":${JSON.stringify(value[valueKey])}`).join(',')}`);
                }

            } else if (typeof value == "number") {
                filters += encodeURIComponent(`"${key}":{"value":${value || 0}`);
            } else if (typeof value == "boolean") {
                filters += encodeURIComponent(`"${key}":{"value":"${value}"`);
            } else {
                filters += encodeURIComponent(`"${key}":{"value":"${value || ''}"`);
            }

            filters += encodeURIComponent(`,"type":"${filterField.constraints[0].matchMode?.toUpperCase()}"}`);

        });
        if (filters.length > 9) {
            filters += encodeURIComponent('}');
        }
    }

    return filters;
}